//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

    name: 'ProductsMixin',

    scrollToTop: true,

    data() {
        return {
            pageMeta: {},
            searchCountry: '',
            searchCategory: '',
            searchQuery: '',
            products: [],
            links: {},
            meta: {},
            paginationUrlRewrite: false,
            paginationIsSearch: false,
            showDetailPopup: false,
            detailProduct: {},
        }
    },


    head() {

        return this.$head()
            .setPage(this.pageMeta)
            .setBodyAttrs('products-body')
            .get()
    },

    filters: {
        limit: function (value, maxLength = 115) {
            if (value.length <= maxLength) return value;
            value = value.substr(0, maxLength -5) + '...';
            return value;
        }
    },

    methods: {

        openPopup(product) {

            //console.log('openPopup', product);

            this.detailProduct = product

            this.$forceNextTick(() => {

                var popup = document.getElementById('popup-product-detail')
                //var popup = this.$refs.popup
                popup.style.display = 'block'
                popup.fadeIn(350)

                let body = document.querySelector('body')
                body.style.overflow = 'hidden'

            })

        },

        closePopup: function () {

            var popup = document.getElementById('popup-product-detail')
            popup.fadeOut(350)
            popup.style.display = 'none'

            let body = document.querySelector('body')
            body.style.overflow = 'auto'

            this.detailProduct = {}

        },

        scrollToResults() {
            this.$scrollTo('#result-section', { offset: -50})
        },

        async onSearch() {

            const params = this.getParams()

            if(params === false) {
                return
            }



            try {

                const result = await this.$axios.$get(this.$ziggy.route('api.products.search'), {
                    params: params
                })

                this.products = result.data
                this.links = result.links;
                this.meta = result.meta;

            } catch (e) {
                console.log(e)
                this.$logger.captureExceptionAxios(e)
            }


        },

        getParams() {

            let params = {
                country: '',
                category: '',
                query: '',
            }

            let valid = false

            if(this.$helper.empty(this.searchCountry) === false && this.searchCountry.code) {
                params.country = this.searchCountry.code
                valid = true
            }

            if(this.$helper.empty(this.searchCategory) === false && this.searchCategory.key) {
                params.category = this.searchCategory.key
                valid = true
            }

            if(this.$helper.empty(this.searchQuery) === false) {
                params.query = this.searchQuery
                valid = true
            }

            if(valid === false) {
                return false
            }

            if(this.page > 1) {
                params.page = this.page
            }

            return params
        },

    },

    computed: {

        showPagination() {

            if(this.$helper.empty(this.links) || this.$helper.empty(this.meta)) {
                return false
            }

            if(this.meta.last_page <= 1) {
                return false
            }

            return true
        },
    }

}

